// @flow
import type { Country } from '../country';
import { getPhoneNumberNormalizerWithLength } from '../../customer-form/get-phone-number-normalizer';

const BRAZIL: Country = {
  code: 'br',
  customerForm: {
    phoneNumber: {
      normalizer: getPhoneNumberNormalizerWithLength(13),
    },
  },
};

export default BRAZIL;
